var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhotoWeb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPhotoWeb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1---USER-STARTS-CALL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPhotoWeb",
    transform: "translate(0.000000, 1.000000)",
    stroke: "#666666",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.68269428,1.91579022 C4.83643565,1.88737906 4.95743122,1.85334278 5.045681,1.81368138 C5.53279562,1.59476133 5.8742971,0.997982599 6.07018545,0.0233451797 C10.7615485,1.31197774 11.2522974,1.95629403 11.8554082,1.95629403 C11.8554082,1.95629403 11.8554082,1.95629403 11.8554082,1.95629403 L11.8554082,1.95629403 C14.1417574,1.95629403 15.9952097,3.80974628 15.9952097,6.0960955 C15.9952097,6.10127196 15.9952,6.10644841 15.9951806,6.11162482 L15.9813062,9.81022713 C15.9709749,12.5643096 13.7354432,14.791471 10.9813414,14.791471 L5.59130076,14.791471 C2.82987701,14.791471 0.591300761,12.5528948 0.591300761,9.79147101 L0.591307652,6.83253359 C0.591307652,4.42154174 2.31184537,2.35391939 4.68269428,1.91579022 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    cx: 8.2962963,
    cy: 8.38095238,
    rx: 1.52400897,
    ry: 1.55491485
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    cx: 8.2962963,
    cy: 8.38095238,
    rx: 3.04801794,
    ry: 3.1098297
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhotoWeb);
export default __webpack_public_path__ + "static/media/icPhotoWeb.31a83228403027622dc9f7d5c608faf3.svg";
export { ForwardRef as ReactComponent };